var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var issueGroupNumbers = function (issue) {
    var _a;
    return ((_a = issue.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length)
        ? __spreadArray([], issue.mergedIssueNumbers, true).sort(function (a, b) { return a - b; })
        : [issue.issueNumber];
};
export var issueGroupMax = function (issue) {
    return Math.max.apply(Math, issueGroupNumbers(issue));
};
// mirrors the backend IssueLabels#mergeLabel, which the saved label must match
export var mergeLabelValues = function (anchorNumber, targetNumbers, volumeLabel) { return ({
    numbers: __spreadArray([anchorNumber], targetNumbers, true).sort(function (a, b) { return a - b; }).join("-"),
    volume: volumeLabel,
}); };
export var crossVolumeMergeLabelValues = function (earlierNumbers, earlierVolumeLabel, laterNumbers, laterVolumeLabel) { return ({
    numbersA: earlierNumbers.join("-"),
    volumeA: earlierVolumeLabel,
    numbersB: laterNumbers.join("-"),
    volumeB: laterVolumeLabel,
}); };
